import React, { useCallback, useState } from "react";
import { useIntl, FormattedMessage } from "react-intl";

import { languages, getLangFlag, completedLanguages } from "../../../../../common/parameters";

import {
    LanguageDropdown,
    LanguageOption,
    Flag,
    LanguageCategory,
    Container,
    Caret
} from "./styles";
import messages from "./messages";
import { IProps } from "./interfaces";

const changeLanguage = (language: string) => {
    window.renderPageWithLanguage(language);
};

const ChangeLanguage = ({ christmas }: IProps) => {
    const { locale, formatMessage } = useIntl();
    const [isOpen, setIsOpen] = useState(false);
    const clickOutsideLanguageMenu = useCallback(() => {
        setIsOpen(false);
        window.removeEventListener("click", clickOutsideLanguageMenu);
    }, [setIsOpen]);
    const toggleLanguageMenu = () => {
        if (!isOpen) {
            setTimeout(() => {
                window.addEventListener("click", clickOutsideLanguageMenu);
            });
        } else {
            window.removeEventListener("click", clickOutsideLanguageMenu);
        }
        setIsOpen(old => !old)
    };

    return (
        <Container onClick={toggleLanguageMenu}>
            <Flag src={`/flags/${getLangFlag(locale)}.png`} />
            <Caret isChristmas={christmas}>
                <svg width="11" height="9">
                    <polygon points="0,0 11,0 5.5,5.5" />
                </svg>
            </Caret>
            {isOpen && (
                <LanguageDropdown isChristmas={christmas}>
                    <LanguageCategory>
                        {languages(formatMessage)
                            .filter(language => completedLanguages.includes(language.value))
                            .map(({ value, label }) => (
                                <LanguageOption
                                    isActive={locale === value}
                                    onClick={() => changeLanguage(value)}
                                    key={value}
                                    isChristmas={christmas}
                                >
                                    <Flag src={`/flags/${getLangFlag(value)}.png`} />
                                    {label}
                                </LanguageOption>
                            ))}
                    </LanguageCategory>
                    <h4>
                        <FormattedMessage {...messages.underDevelopment} />
                    </h4>
                    <LanguageCategory>
                        {languages(formatMessage)
                            .filter(language => !completedLanguages.includes(language.value))
                            .map(({ value, label }) => (
                                <LanguageOption
                                    isActive={locale === value}
                                    onClick={() => changeLanguage(value)}
                                    key={value}
                                >
                                    <Flag src={`/flags/${getLangFlag(value)}.png`} />
                                    {label}
                                </LanguageOption>
                            ))}
                    </LanguageCategory>
                </LanguageDropdown>
            )}
        </Container>
    );
};

export default ChangeLanguage;
